<template>
  <ProductForm
    :product="$store.state.products.product"
    :onSubmit="submit"
  ></ProductForm>
</template>

<script>
import { mapActions } from 'vuex';
import ProductForm from './ProductForm.vue';
import { busEvent } from '../../main';

export default {
  name: 'EditProduct',
  components: {
    ProductForm,
  },
  created() {
    this.getProduct(this.$route.params.id);
  },
  methods: {
    ...mapActions('products', ['getProduct', 'update']),

    async submit() {
      await this.update(this.$route.params.id);
      busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
      this.$router.push({ path: '/products' });
    },
  },
};
</script>
